<div class="card">
  <div class="md:tw-flex tw-rounded-lg tw-bg-yellowLight md:tw-col-span-2">
    <div class="md:tw-flex tw-items-end tw-w-24 tw-hidden">
      <img style="height: 80%; margin-left: 15%;" src="assets/images/perfect-car-left.svg" alt="">
    </div>
    <div class="tw-flex tw-flex-grow tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-p-8">
      <p class="tw-text-3xl tw-font-bold">Can't find the perfect car?</p>
      <p class="tw-text-gray-700">Let us help you on a quick call</p>
      <br>
      <form [formGroup]="callbackForm">
        <div class="tw-flex tw-justify-center">
          <input formControlName="mobile" placeholder="Mobile number" type="number"
            class="tw-rounded-l-md tw-border tw-border-yellow focus:tw-outline-yellow tw-px-3 tw-py-2" />
          <button (click)="getCallback()" class="tw-rounded-r-md tw-text-white tw-px-2 tw-bg-yellow">GET
            CALLBACK</button>
        </div>
        <span class="tw-text-redMid tw-text-sm"
          *ngIf="callbackForm.controls['mobile'].touched && callbackForm.controls['mobile'].errors?.['required']">
          Mobile number is required
        </span>
        <span class="tw-text-redMid tw-text-sm"
          *ngIf="!callbackForm.controls['mobile'].errors?.['required'] && callbackForm.controls['mobile'].touched && callbackForm.controls['mobile'].invalid">
          Invalid Mobile number
        </span>
      </form>
    </div>
    <div class="md:tw-flex tw-items-end tw-w-24 tw-hidden">
      <img style="height: 80%;" src="assets/images/perfect-car-right.svg" alt="">
    </div>
  </div>
</div>